module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"title":"Alguma coisa deu errado.","subtitle":"Nós monitoramos o erro automaticamente, <br> mas se o problema persistir sinta-se livre para entrar em contato conosco.","button":"Recarregar"},"en-US":{"title":"Something wrong happended","subtitle":"We track error automatically, <br> but if problem persist feel free to contact us.","button":"Refresh"}}')
  delete Component.options._Ctor
}
